import { PrimaryBuyerUser } from "../../../types/models/BuyerUser";
import BuyerUserName from "./BuyerUserName";
import { buyerUserApi } from "../../../apis/BuyerUser.api.ts";
import {linkPath as linkPathParent} from "../../../../timber/components/buyer/BuyerDetail/BuyerLink";    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    const {data} = await dispatch(buyerUserApi.endpoints.getBuyerUser.initiate(PrimaryBuyerUser.fromId(id)))
    const prefix = await linkPathParent(dispatch, data.buyerId)
    return `${prefix}/buyer-users/${PrimaryBuyerUser.fromId(id).toPath()}`
}

const BuyerUserLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <BuyerUserName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<BuyerUserName id={id}/>)
    else
        return undefined
}
export default BuyerUserLink;
